export interface SweetFaceTerminalFunctionsConfiguration {
  refund: boolean;
  wallet: boolean;
  deposits: boolean;
  tickets: boolean;
  giftCards: boolean;
  invoices: boolean;
  saleAmount: boolean;
  preAuth: boolean;
}
